import { useQuery } from '@tanstack/react-query';
import productService from 'v2/services/product';

export function useProductInvoices(productId: number) {
  return useQuery({
    queryKey: ['product', productId, 'invoices'],
    queryFn: () => productService.getInvoices(productId),
    enabled: false
  });
}
